import { ArrowRight } from "lucide-react";

export default function OrangeCTA({
  children,
  as = "a",
  href,
  type,
  full = false,
  onClick,
}: {
  children: React.ReactNode;
  as?: "a" | "button";
  href?: string;
  type?: "button" | "submit";
  full?: boolean;
  onClick?: () => void;
}) {
  const cls = `group inline-flex ${full ? "w-full" : ""} items-center justify-center gap-2 rounded-full px-6 py-3.5 font-display text-[13px] font-semibold tracking-wide text-white btn-orange btn-orange-hover`;
  if (as === "button" || onClick)
    return (
      <button type={type ?? "button"} onClick={onClick} className={cls}>
        {children}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
      </button>
    );
  return (
    <a href={href} className={cls}>
      {children}
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
    </a>
  );
}